/**
 * Fallback avatar fill for workspaces with no uploaded logo, shared by the
 * workspace picker and the inline switcher so the two surfaces cannot drift
 * apart.
 *
 * Deliberately not a DS token: the only gradient the DS exposes is
 * `--brand-grad`, a bright magenta sweep that is unreadable behind a white
 * workspace initial.
 */
export const WORKSPACE_AVATAR_GRADIENT =
  "linear-gradient(135deg, #2d1f5a 0%, #3a2870 50%, #1f1638 100%)";
